import { render, staticRenderFns } from "./EditEmployeeCoverageModal.vue?vue&type=template&id=52b06803&scoped=true&"
import script from "./EditEmployeeCoverageModal.vue?vue&type=script&lang=js&"
export * from "./EditEmployeeCoverageModal.vue?vue&type=script&lang=js&"
import style0 from "./EditEmployeeCoverageModal.vue?vue&type=style&index=0&id=52b06803&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b06803",
  null
  
)

component.options.__file = "EditEmployeeCoverageModal.vue"
export default component.exports